import { NavLink } from 'react-router-dom';
import { cn } from '../../utils';

const navItems = [
  { to: '/', icon: 'chart', label: '行情' },
  { to: '/trend', icon: 'trend', label: '走势' },
  { to: '/compare', icon: 'compare', label: '对比' },
  { to: '/news', icon: 'news', label: '新闻' },
  { to: '/advice', icon: 'advice', label: '建议' },
];

const icons: Record<string, React.ReactNode> = {
  chart: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  trend: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <line x1="18" y1="20" x2="18" y2="10" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="20" x2="12" y2="4" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="6" y1="20" x2="6" y2="14" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  compare: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="3" y1="9" x2="21" y2="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="9" y1="21" x2="9" y2="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  news: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="14 2 14 8 20 8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16" y1="13" x2="8" y2="13" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16" y1="17" x2="8" y2="17" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  advice: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="16" x2="12" y2="12" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

export function MobileTabBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-surface border-t border-border z-50 lg:hidden safe-area-pb">
      <div className="flex items-center justify-around h-14">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-0.5 px-3 py-1 min-w-[60px]',
                isActive
                  ? 'text-primary'
                  : 'text-text-muted hover:text-text-secondary'
              )
            }
          >
            {icons[item.icon]}
            <span className="text-[10px] font-medium">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
